import axios from 'axios';
import {clarify} from "../utils/clear";

class EndpointApi {
    constructor() {
        this.endpoint =  process.env.VUE_APP_BASE_API;
    }

    getList(body) {
        const params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/endpoint/list`, {params}).then(response=>response.data);
    }

    // getEndpoint(endpointUrl, requestType) {
    //     return axios.get(`${this.endpoint}/endpoint?endpointUrl=${endpointUrl}&requestType=${requestType}`, {}).then(response=>response.data);
    // }
    getExists(endpointUrl, requestType) {
        return axios.get(`${this.endpoint}/endpoint/exists?endpointUrl=${endpointUrl}&requestType=${requestType}`, {}).then(response=>response.data);
    }

    save(endpoint) {
        return axios.post(`${this.endpoint}/endpoint/save`, endpoint).then(response=>response.data);
    }

    deleteEndpoint(endpointUrl, requestType) {
        console.log(endpointUrl);
        return axios.delete(`${this.endpoint}/endpoint/delete?endpointUrl=${endpointUrl}&requestType=${requestType}`, {}).then(response=>response.data);
    }



}

export default new EndpointApi();
